import React, {PropsWithChildren} from 'react';
import clsx from 'clsx';

import PaymentSupportItem, {PaymentSupportProps} from '../PaymentSupportItem';
import GearLoadingIcon from '../Icon/GearLoadingIcon';
import WithBorder from '../WithBorder';
import {ChevronRight} from '../Icon';

import {useTranslation} from 'react-i18next';

import styles from './PaymentSupport.module.css';


interface MethodItemProps {
  className?: string
  method: string
  supports: PaymentSupportProps[]
  isLoading: boolean

  onClick(): void
}


const PaymentSupport = (
  {
    className,
    method,
    supports,
    children,
    isLoading,
    onClick,
  }: PropsWithChildren<MethodItemProps>) => {

  const {t} = useTranslation();

  return (
    <div className={className}>
      <div className={styles.method} onClick={onClick}>
        <div>
          {method}
        </div>
        <div>
          {
            isLoading ?
              <div className="flex centered">
                <span style={{color: 'var(--secondary-color)', marginRight: 5, whiteSpace: 'nowrap'}}>
                  {t('redirectToGateway')}
                </span>
                <GearLoadingIcon width={24} height={24}/>
              </div>
              :
              <ChevronRight/>
          }
        </div>
      </div>
      <WithBorder borders="top" borderStyle="1px solid var(--gray-color)"/>
      <div className={styles.supports}>
        {
          supports.map((method, index) => {
            const hasStringChildren = typeof method.children === 'string';

            return (
              <PaymentSupportItem
                key={index}
                className={clsx(styles.item, hasStringChildren && styles.stringChild)}
                itemClassName={styles.itemBorder}
                src={method.src}
                isFull={method.isFull}
                additionalText={method.additionalText && t(method.additionalText)}
                onClick={onClick}
              >
                {hasStringChildren ? t(method.children as string) : method.children}
              </PaymentSupportItem>
            )
          })
        }
      </div>
    </div>
  );
};

export default PaymentSupport;
